"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HE3Refinery = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Resources_1 = require("../../Resources");
var HE3Refinery = (function (_super) {
    __extends(HE3Refinery, _super);
    function HE3Refinery() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HE3_REFINERY,
            cost: 8,
            tags: [Tags_1.Tags.MOON],
            metadata: {
                cardNumber: 'M49',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Gain 1 M€ for each level of Mining Rate.', function (eb) {
                        eb.empty().startAction;
                        eb.megacredits(1).slash().moonMiningRate();
                    });
                }),
            },
        }) || this;
    }
    HE3Refinery.prototype.play = function () {
        return undefined;
    };
    HE3Refinery.prototype.canAct = function () {
        return true;
    };
    HE3Refinery.prototype.action = function (player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, MoonExpansion_1.MoonExpansion.moonData(player.game).miningRate, { log: true });
        return undefined;
    };
    return HE3Refinery;
}(Card_1.Card));
exports.HE3Refinery = HE3Refinery;
//# sourceMappingURL=HE3Refinery.js.map